import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=ce844784&"
import script from "./PageLoader.vue?vue&type=script&lang=js&"
export * from "./PageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce844784')) {
      api.createRecord('ce844784', component.options)
    } else {
      api.reload('ce844784', component.options)
    }
    module.hot.accept("./PageLoader.vue?vue&type=template&id=ce844784&", function () {
      api.rerender('ce844784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loader/PageLoader.vue"
export default component.exports